module.exports = __webpack_public_path__ + "img/CR.ee6e72d4.svg";